import React, { lazy, Suspense, useState } from 'react'
import { useMenuOverlay, useOverlay } from '@fs/zion-ui'
import { useEvent } from '@fs/zion-frontend-friends'
import { GenealogyTreeMenuSkeleton } from '../GenealogyTreeMenu'

const GenealogyTreeMenu = lazy(() => import('../GenealogyTreeMenu'))
const DeleteOverlay = lazy(() => import('./DeleteOverlay'))

export default function useGenealogyTreeMenu() {
  const menuOverlay = useMenuOverlay()
  const deleteOverlay = useOverlay()
  const [treeSelected, setTreeSelected] = useState({})

  const onMenuClick = useEvent((event, selectedTree) => {
    setTreeSelected(selectedTree)
    menuOverlay.open(event)
  })

  const genealogyActionsOverlay = (
    <>
      {(menuOverlay.isOpen || menuOverlay.transitioning) && (
        <Suspense fallback={<GenealogyTreeMenuSkeleton menuOverlay={menuOverlay} />}>
          <GenealogyTreeMenu onDeleteClick={deleteOverlay.handleClick} menuOverlay={menuOverlay} tree={treeSelected} />
        </Suspense>
      )}

      {(deleteOverlay.isOpen || deleteOverlay.transitioning) && (
        <Suspense fallback="">
          <DeleteOverlay overlay={deleteOverlay} tree={treeSelected} />
        </Suspense>
      )}
    </>
  )

  return {
    menuButtonProps: menuOverlay.menuButtonProps,
    genealogyActionsOverlay,
    onMenuClick,
  }
}
